import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logApiCall, addInitiatorHeaders } from './apiDebugger';
import { setSessionVar } from '../lib/helpers';

// Base query configuration
const baseQuery = fetchBaseQuery({
    baseUrl: '/api/v3',
    prepareHeaders: (headers) => {
        if (!headers.has('accept')) {
            headers.set('accept', 'application/json');
        }
        if (!headers.has('X-Requested-With')) {
            headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // Add initiator tracking headers for debugging
        addInitiatorHeaders(headers);
        return headers;
    },
});

/**
 * Custom baseQuery wrapper that handles 401 Unauthorized responses
 * Automatically redirects to sign-in page when authentication fails
 * Updates session activity time on each API call,
 * which is used by the SessionTimeoutProvider to manage session expiration warnings and automatic logout.
 */
const baseQueryWithChecks = async (args, api, extraOptions) => {
    // Log API call with initiator information (for debugging)
    logApiCall(args, api);
    let result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401) {
        sessionStorage.clear();
        localStorage.clear();

        // Get current path to avoid infinite redirect loop
        const currentPath = window.location.pathname;

        // Only redirect if not already on signin page
        if (currentPath !== '/') {
            // Redirect to sign-in page
            window.location.href = '/';
        }
    } else {
        setSessionVar('lastActivityTime', Date.now());
    }

    return result;
};

export const rivermeadowApi = createApi({
    reducerPath: 'rivermeadowApi',
    baseQuery: baseQueryWithChecks,
    tagTypes: [
        'SOURCES',
        'SOURCE_INSPECTION',
        'SOURCE_INVENTORY',
        'MOVE_GROUPS',
        'MOVEGROUPS',
        'APPLICATIONS',
        'DISCOVERY_INVENTORY',
        'CLOUD_ACCOUNTS',
        'APPLIANCES',
        'PREFLIGHTS',
        'MIGRATIONS',
        'MIGRATION_PROFILES',
        'USER',
        'USERS',
        'TAGS',
        'ORGANIZATION',
        'FILTERED_DISCOVERY_INVENTORY',
        'USER_CUSTOMIZATIONS',
    ],
    endpoints: () => ({}),
});
